<template>
  <div class="widget projecttype">
    <h3 v-if="Initialtitle">
        <img src="/static/images/icons/submission_icon_blue.svg" class="dashboard-icons" />
        <span>Project Type</span>
    </h3>
    <div class="widget-body">
      <table class="bar-graph">
        <tbody>
          <tr>
            <td class="bar-wrapper" v-for="(item, index) in data" :key="index">
              <div class="value">{{ item.value }}</div>
              <base-tooltip :content="item.label" placement="top">
                <div class="bar" :style="{ height: item.height }"></div>
              </base-tooltip>
            </td>
          </tr>
          <tr class="labels">
            <td v-for="(item, index) in data" :key="index">
              {{ item.label.length > 4 ? `${item.label.slice(0, 3)}...` : item.label }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <loader :loadingStatus="loaderStatus"></loader>
  </div>
</template>
<script>
import Loader from '../../../UIComponents/Loader.vue';
import BaseTooltip from '../../../Common/BaseTooltip.vue';

export default {
  props: ['Initialtitle', 'sbData', 'name', 'type'],
  data() {
    return {
      data: [],
      loaderStatus: false,
    };
  },
  components: {
    Loader,
    BaseTooltip,
  },
  created() {
    this.accessData();
  },
  methods: {
    async accessData() {
      this.loaderStatus = true;
      const x = this.sbData;
      this.loaderStatus = false;
      this.data = x.projectTypeGraphData;
      this.data.map((item) => {
        const newItem = item;
        newItem.height = `${item.height.split('px')[0]}px`;
        return newItem;
      });
    },
  },
};
</script>
<style scoped>
.dashboard-icons {
  width: 32px;
  height: 32px;
}
.h3 span {
  padding-left:14px;
}
.widget-body {
  height: 190px;
  overflow-y: auto;
}
.widget .bar-graph .bar {
  width: 10px;
  background-color: #4c9e45;
  border-radius: 13px;
  margin: auto;
}
.widget .bar-graph .bar-wrapper {
  position: relative;
  vertical-align: bottom;
  padding-bottom: 3px;
}
.widget .bar-graph {
  width: 100%;
  height: 90%;
  table-layout: fixed;
  font-size: 12px;
}
.widget .bar-graph td {
  text-align: center;
  font-size: 9px;
  font-weight: 500;
}
.widget .bar-graph .bar {
  width: 10px;
  background-color: #4c9e45;
  border-radius: 13px;
  margin: auto;
}
.widget .bar-graph .bar-wrapper {
  position: relative;
  vertical-align: bottom;
  padding-bottom: 3px;
}
td,
th {
  padding: 0;
}
.widget .bar-graph .labels td {
  border-top: 0.5px dashed #bdbdbd;
  height: 15px;
  padding-top: 5px;
}
.projecttype h3 {
  margin: 0;
  line-height: 28px;
  color: #0b3c61;
  font-size: 22px;
  font-weight: 500;
}
.MT-25 {
  margin-top: 25px;
}
.cursor-pointer {
  word-break: break-all;
  white-space: normal;
}
@media only screen and (max-width: 1024px) {
  .widget {
    margin-bottom: 20px !important;
    min-height: 245px !important;
  }
}
</style>
